let fontawesomeFreeSolidIcons: any = {};
try {
  fontawesomeFreeSolidIcons = require('@fortawesome/free-solid-svg-icons');
} catch (err) {}

export default fontawesomeFreeSolidIcons;
